import { COLORS } from "components/consts";
import { SIDEBAR_DIMENSIONS } from "./consts";

// Shared sidebar item styles — single source of truth lives in ../../styles
export {
  listItemStyles,
  listItemButtonStyles,
  iconContainerStyles,
  listItemIconStyles,
  listItemTextStyles,
  sidebarTitleStyles,
  sidebarTitleTextStyles,
} from "../../styles";

// Expandable-menu-specific styles
export const arrowContainerStyles = {
  ml: "100px",
};

export const modalStyles = {
  height: SIDEBAR_DIMENSIONS.ITEM_HEIGHT,
  borderRadius: 2,
  "&.Mui-selected": {
    backgroundColor: "background.default",
    ":hover": {
      backgroundColor: "background.default",
    },
  },
  ".MuiListItemButton-root": {
    ":hover": {
      backgroundColor: "transparent",
    },
  },
};

export const modalItemTextStyles = {
  "& .MuiListItemText-primary": {
    fontSize: "12px",
    color: COLORS.Romance,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "24px",
  },
};

export const collapseItemStyles = (isOpen: boolean) => ({
  pl: isOpen ? 4 : 0,
  height: SIDEBAR_DIMENSIONS.ITEM_HEIGHT,
  ml: 1,
  borderRadius: 2,
  justifyContent: !isOpen ? "center" : undefined,
  "&.Mui-selected": {
    backgroundColor: "background.default",
    ":hover": {
      backgroundColor: "background.default",
    },
  },
  ".MuiListItemButton-root": {
    ":hover": {
      backgroundColor: "transparent",
    },
  },
});

export const dropLineStyles = {
  minWidth: "12px",
  position: "absolute" as const,
  left: "43px",
  mt: 0,
  zIndex: 9999,
};

export const collapseItemIconStyles = (isOpen: boolean) => ({
  minWidth: isOpen ? "40px" : 0,
});

export const collapseItemTextStyles = {
  marginLeft: "-10px",
  "& .MuiListItemText-primary": {
    color: COLORS.Romance,
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "24px",
  },
};
